


































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Employer from '@/models/Employer';
import ContactInfo from '@/models/ContactInfo';
import User from '@/models/User';
import { batman } from '@/data';
import { EventBus } from '@/event-bus';

@Component
export default class EmployerRegistration extends Vue {
  employer = new Employer();
  contactInfo: ContactInfo = {
    street: '123 Main St',
    city: 'Chicago',
    zipcode: '60606',
    phone: '1234567890'
  };
  valid = true;
  firstNameRules = [v => !!v || 'First Name is required'];
  lastNameRules = [v => !!v || 'Last Name is required'];
  emailRules = [v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid'];
  streetRules = [v => !!v || 'Street is required'];
  cityRules = [v => !!v || 'City is required'];
  zipcodeRules = [v => !!v || 'Zipcode is required', v => /^[0-9]+$/.test(v) || 'Zipcode is numeric only'];
  ktpRules = [v => !!v || 'KTP is required', v => /^[0-9]+$/.test(v) || 'Ktp is numeric only'];
  phoneRules = [v => !!v || 'Phone is required', v => /^[0-9]+$/.test(v) || 'Phone is numeric only'];
  @Getter
  currentUser: User;

  mounted() {
    this.employer = batman;
    this.employer.userEmail = this.currentUser.email;
  }

  submit() {
    if ((this.$refs.form as any).validate()) {
      this.employer.contactInfo = this.contactInfo;
      EventBus.$emit('loading', 'submitting');
      this.$store.dispatch('registerEmployer', this.employer).then(_ => {
        this.$router.replace('employerHome');
        EventBus.$emit('loaded');
      });
    }
  }

  clear() {
    (this.$refs.form as any).reset();
  }
}
